module.exports = __webpack_public_path__ + "hide_balance_icon.png?e7a8eabace7e509b699973d84bb8b661";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hide_balance_icon.png
// module id = 1030
// module chunks = 2